import type { SVGProps } from 'react';
const SvgInfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.5}
    className="info-circle_svg__icon info-circle_svg__icon-tabler info-circle_svg__icon-tabler-info-circle"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" />
    <circle cx={12} cy={12} r={9} />
    <path d="M12 8h.01M11 12h1v4h1" />
  </svg>
);
export default SvgInfoCircle;
